import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isNaN } from 'lodash'

import { Filters } from 'components'

import helpers from 'helpers'

import useDataProcessOptions from 'hooks/useDataProcessOptions'
import useAssetInventory from 'hooks/useAssetInventory'

import constants from 'constants/index'

const DataIntelligenceFilter = ({ filter }) => {
  const [eventSources, setEventSources] = useState()
  const [dataSources, setDataSources] = useState([])
  const [otherSourceValue, setOtherSourceValue] = useState('')

  const {
    DATA_TYPE_OPTIONS,
    SOURCE_DESCRIPTION_FIELD,
    SOURCE_DESCRIPTION_OPTIONS,
    DATA_PROCESS_SOURCES_FIELD,
    SOURCE_DESCRIPTION_IDS_OPTIONS,
    ANOTHER_SOURCE,
    SHARE_TYPE_OPTIONS,
  } = constants.dataProcess
  const { OPTION_AGE_RANGE } = constants.dataCollected
  const { OPTIONS_TYPES } = constants.dataTreatmentAgents

  const { data } = useDataProcessOptions()
  const { assetInventoryCategories, loadingCategories } = useAssetInventory()

  const optionAgeRange = OPTION_AGE_RANGE.map((option) => ({
    ...option,
    id: String(option.id),
  }))

  const filterKey = JSON.stringify({
    filters: filter.filters,
    drawerOpen: filter.drawerOpen,
  })

  const changeDataSources = (value) => {
    const optionsFormatted = helpers.dataProcess.mountDataProcessSources(
      data?.options?.dataProcessSources || [],
      data?.options?.departments || [],
      value,
    )
    setDataSources(optionsFormatted)
  }

  const handleChangeSource = (event) => {
    const value = parseInt(event.target.value)

    setEventSources(value)
    changeDataSources(value)
  }

  useEffect(() => {
    const { sourceDescription } = filter.filters

    if (!sourceDescription) return setEventSources(undefined)

    const numberSource = Number(sourceDescription)
    if (isNaN(numberSource))
      return setEventSources(constants.dataProcess.ANOTHER_SOURCE)

    changeDataSources(numberSource)
    setEventSources(numberSource)
    //eslint-disable-next-line
  }, [data, filter.filters])

  useEffect(() => {
    if (eventSources === ANOTHER_SOURCE) {
      if (!isNaN(Number(filter.filters.sourceDescription)))
        setOtherSourceValue('')
      else setOtherSourceValue(filter.filters.sourceDescription || '')
    }
  }, [eventSources, filter.filters.sourceDescription, ANOTHER_SOURCE])

  return (
    <Filters filter={filter} key={filterKey} hiddenOrderBy>
      <select
        multipleselectinput="true"
        label="Faixa etária"
        name="titularAgeRanges"
        optionvalues={optionAgeRange}
      />
      <select
        multipleselectinput="true"
        label="Departamento"
        name="departmentId"
        optionvalues={data?.options?.departments || []}
      />
      <select
        textfieldinput="true"
        label="Origem"
        value={eventSources}
        name={SOURCE_DESCRIPTION_FIELD}
        onChange={handleChangeSource}
        willclearfield={DATA_PROCESS_SOURCES_FIELD}
      >
        {SOURCE_DESCRIPTION_OPTIONS.map((item, index) => (
          <option key={index} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      {SOURCE_DESCRIPTION_IDS_OPTIONS.includes(eventSources) && (
        <select
          multipleselectinput="true"
          name={DATA_PROCESS_SOURCES_FIELD}
          label={helpers.dataProcess.getSourceFilterLabel(eventSources)}
          optionvalues={dataSources?.map((source) => ({
            id: source.entityId,
            name: source.entityName,
          }))}
        />
      )}
      {ANOTHER_SOURCE === eventSources && (
        <input
          textfieldinput="true"
          name={SOURCE_DESCRIPTION_FIELD}
          label="Outra origem"
          value={otherSourceValue}
          onChange={(e) => setOtherSourceValue(e.target.value)}
          required
        />
      )}
      <select
        multipleselectinput="true"
        compareByName="true"
        label="Dado tratado"
        name="dataCollectedOptionNames"
        optionvalues={helpers.dataProcess.formatByNameInFilter(
          data?.options?.dataCollectedOptions,
        )}
      />
      <select
        multipleselectinput="true"
        label="Categoria do titular"
        name="titularCategories"
        optionvalues={data?.options?.titularCategories || []}
      />
      <select
        multipleselectinput="true"
        label="Tipo de dados"
        name="dataTypes"
        optionvalues={DATA_TYPE_OPTIONS}
      />
      <select
        multipleselectinput="true"
        label="Agentes de tratamento"
        name="agentType"
        optionvalues={OPTIONS_TYPES}
      />
      <select
        multipleselectinput="true"
        label="Categoria do inventário de ativos"
        name="assetInventoryCategories"
        optionvalues={assetInventoryCategories || []}
        loading={loadingCategories}
      />
      <select
        textfieldinput="true"
        label="Ambiente de alocação"
        name="internalAllocationMode"
      >
        <option value="" />
        {SHARE_TYPE_OPTIONS.map((item, index) => (
          <option key={index} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      <select
        multipleselectinput="true"
        compareByName="true"
        label="Compartilhado com"
        name="shareProcessNames"
        optionvalues={helpers.dataProcess.formatByNameInFilter(
          data?.options?.shareProcesses,
        )}
      />
      <select
        textfieldinput="true"
        label="Transferência internacional"
        name="haveInternationalTransfer"
      >
        <option value=""></option>
        <option value={true}>Sim</option>
        <option value={false}>Não</option>
      </select>
    </Filters>
  )
}

DataIntelligenceFilter.propTypes = {
  filter: PropTypes.object.isRequired,
}

export default DataIntelligenceFilter
